module.exports = __webpack_public_path__ + "static/media/userIcon.879ce490.png";